
<div class="p-2">
    <div style="margin-bottom: 24px">
        <div class="d-flex justify-content-between align-items-center">
            <p class="titre1">Organisations de comptabilité</p>
        </div>
    </div>

    <div class="row justify-content-center">
        <div class="col-md-6 mb-4">
            <div class="card text-center  h-100" style="border: 1px solid #2F2B3D1F;" [class.card-selected]="selectedOrg === 'org1'" (click)="selectCard('org1')">
                <img src="../../../../assets/images/pages/comptable/Compagnie des des comptables de Tunisie.png"
                     class="mx-auto" alt="Image 1"
                     style="width: 80px;margin: 16px 0 8px 0">
                <h6 class="card-title" style="margin-bottom: 8px">Compagnie des des comptables de Tunisie</h6>
                <p class="card-text text-muted" style="margin-bottom: 14px">Organisation 1</p>
                <div class="org-radio-wrapper" >
                    <input type="radio" name="organisation" id="org1" value="org1" [checked]="selectedOrg === 'org1'" (change)="selectCard('org1')" class="org-radio-input">
                    <label class="org-radio-label" for="org1">
                        <span class="org-radio-dot"></span>

                    </label>
                </div>
            </div>
        </div>

        <div class="col-md-6 mb-4">
            <div class="card text-center h-100" style="border: 1px solid #2F2B3D1F;" [class.card-selected]="selectedOrg === 'org2'" (click)="selectCard('org2')">
                <img src="../../../../assets/images/pages/comptable/Ordre des experts comptables de Tunisie.png"
                     class="mx-auto" alt="Image 2"
                     style="width: 80px;margin: 16px 0 8px 0">
                <h6 class="card-title "  style="margin-bottom: 8px">Ordre des experts comptables de Tunisie</h6>
                <p class="card-text text-muted" style="margin-bottom: 14px">Organisation 2</p>
                <div class="org-radio-wrapper" >
                    <input type="radio" name="organisation" id="org2" value="org2" [checked]="selectedOrg === 'org2'" (change)="selectCard('org2')" class="org-radio-input">
                    <label class="org-radio-label" for="org2">
                        <span class="org-radio-dot"></span>

                    </label>
                </div>
            </div>
        </div>


    </div>
    <h6>Réference(<span class="text-danger">*</span>)</h6>
    <div class="d-flex align-items-center " style="width: 515px;">
        <div class="input-group">
            <div class="input-group-prepend color-box" >
                <span class="input-group-text color-box" id="basic-addon-search1">CCT</span>
            </div>
            <input
                    type="text"
                    class="form-control"
                    style="height: 38px"
                    placeholder="Entrez la réference de votre comptable "
                    aria-label="Entrez la réference de votre comptable "
                    aria-describedby="basic-addon-search1"
            />
            <div style="width: 38px; margin-left: 6px;">
                <button class="btn btn-primary btn-sm d-flex align-items-center justify-content-center" type="button" style="width: 38px; height: 38px; padding: 0;">
                    <i data-feather="search" class="feather-icon"></i>
                </button>
            </div>
        </div>

    </div>
</div>

